<template>
  <el-container>
    <el-form :model="rowData" label-width="120px">
      <el-form-item label="供应商:">
        {{rowData.supply_org_name}}
      </el-form-item>
      <el-form-item label="合作模式:" prop="device_purpose">
        {{rowData.device_purpose_desp}}
      </el-form-item>
      <el-form-item label="验签密钥:">
        {{rowData.secret_key}}
      </el-form-item>
      <el-form-item label="软件版本号:" prop="device_type_id">
        {{rowData.software_version}}
      </el-form-item>
      <el-form-item label="数据更新时间:">
        {{rowData.parameter_report_time}}
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  },

  props: ['rowData'],

  methods: {}
}
</script>
